import { createBreakpoints, } from "./createBreakpoints";
import { createSpacing } from "./createSpacing";
import { createShape } from "./shape";
export function createThemeOptions(options) {
    return options;
}
export function createTheme(data) {
    const result = {
        direction: "ltr",
        shadows: undefined,
        transitions: undefined,
        components: undefined,
        palette: undefined,
        typography: undefined,
        zIndex: undefined,
        mixins: undefined,
        ...data,
        breakpoints: createBreakpoints(data?.breakpoints),
        shape: createShape(data?.shape),
        spacing: createSpacing(data?.spacing),
    };
    return result;
}
export default createTheme;
